/* tslint:disable */
/* eslint-disable */
/**
 * ConfigHub API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RepositoryFile
 */
export interface RepositoryFile {
    /**
     * 
     * @type {string}
     * @memberof RepositoryFile
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof RepositoryFile
     */
    path?: string;
    /**
     * 
     * @type {string}
     * @memberof RepositoryFile
     */
    lastModified?: string;
}

export function RepositoryFileFromJSON(json: any): RepositoryFile {
    return RepositoryFileFromJSONTyped(json, false);
}

export function RepositoryFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepositoryFile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'lastModified': !exists(json, 'lastModified') ? undefined : json['lastModified'],
    };
}

export function RepositoryFileToJSON(value?: RepositoryFile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'path': value.path,
        'lastModified': value.lastModified,
    };
}


